import React, { useState, useEffect } from 'react';
import Header from '../../components/navigation/Header';
import SearchModal from '../../components/navigation/SearchModal';
import HeroSection from './components/HeroSection';
import InteractiveMap from './components/InteractiveMap';
import FilterPanel from './components/FilterPanel';
import DestinationCard from './components/DestinationCard';
import DestinationModal from './components/DestinationModal';
import SafetySection from './components/SafetySection';
import FeaturedPartners from './components/FeaturedPartners';
import EmergencyBanner from './components/EmergencyBanner';
import OfficialPartners from './components/OfficialPartners';
import Footer from './components/Footer';


const Homepage = () => {
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [activeFilters, setActiveFilters] = useState([]);
  const [selectedDestination, setSelectedDestination] = useState(null);
  const [isDestinationModalOpen, setIsDestinationModalOpen] = useState(false);

  const destinations = [
  {
    id: 1,
    name: 'Boracay',
    location: 'Aklan, Western Visayas',
    description: 'World-famous white sand beaches and crystal-clear waters perfect for water sports and relaxation',
    fullDescription: 'Boracay is a tropical paradise known for its powdery white sand beaches, vibrant nightlife, and world-class water sports. The island offers a perfect blend of relaxation and adventure, with stunning sunsets, diverse dining options, and activities ranging from kiteboarding to island hopping. Whether you seek tranquility or excitement, Boracay delivers an unforgettable Philippine experience.',
    image: "https://images.unsplash.com/photo-1670577528957-9114b37c8080",
    imageAlt: 'Aerial view of Boracay white sand beach with turquoise waters, traditional boats, and palm trees lining the shore',
    rating: 4.8,
    reviews: 12453,
    priceFrom: 2500,
    isHiddenGem: false,
    isFeatured: true,
    features: [
    { icon: 'Waves', label: 'White Sand Beach' },
    { icon: 'Wind', label: 'Water Sports' },
    { icon: 'Sunset', label: 'Sunset Views' },
    { icon: 'Music', label: 'Nightlife' }],

    gallery: [
    {
      url: "https://images.unsplash.com/photo-1565700439673-3db3aad31e64",
      alt: 'Panoramic view of Boracay beach with white sand, clear blue water, and traditional Filipino boats'
    },
    {
      url: "https://images.unsplash.com/photo-1660378930729-b09d8600006e",
      alt: 'Boracay sunset with orange and pink sky reflecting on calm ocean waters'
    },
    {
      url: "https://images.unsplash.com/photo-1671579878226-0f4af971d338",
      alt: 'Boracay beach activities showing tourists enjoying water sports and beach volleyball'
    }],

    hotels: [
    {
      name: 'Shangri-La Boracay',
      rating: 4.9,
      price: 8500,
      image: "https://images.unsplash.com/photo-1708020777210-3ff7cb1ca574",
      imageAlt: 'Luxury Shangri-La Boracay resort exterior with modern architecture, infinity pool, and ocean views'
    },
    {
      name: 'Discovery Shores',
      rating: 4.7,
      price: 7200,
      image: "https://images.unsplash.com/photo-1611222565146-f0e39f5217f7",
      imageAlt: 'Discovery Shores beachfront resort with white buildings, tropical gardens, and private beach access'
    }],

    restaurants: [
    {
      name: 'Aria Cucina Italiana',
      cuisine: 'Italian',
      avgPrice: 1200,
      image: "https://images.unsplash.com/photo-1610894803089-0c3283d8d059",
      imageAlt: 'Elegant Italian restaurant interior with wooden tables, warm lighting, and Mediterranean decor'
    },
    {
      name: 'Dos Mestizos',
      cuisine: 'Spanish-Filipino',
      avgPrice: 950,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_13c9964da-1765211058221.png",
      imageAlt: 'Cozy Spanish-Filipino fusion restaurant with rustic wooden furniture and traditional Filipino art'
    }],

    transport: [
    {
      type: 'Ferry Transfer',
      description: 'Caticlan to Boracay round trip',
      price: 450,
      icon: 'Ship'
    },
    {
      type: 'Island Hopping',
      description: 'Full day tour with lunch',
      price: 1800,
      icon: 'Anchor'
    }]

  },
  {
    id: 2,
    name: 'El Nido',
    location: 'Palawan, MIMAROPA',
    description: 'Stunning limestone cliffs, hidden lagoons, and pristine beaches in a tropical paradise',
    fullDescription: 'El Nido is a breathtaking destination featuring dramatic limestone karst cliffs, secret lagoons, and some of the most beautiful beaches in the world. This natural wonder offers incredible island hopping tours, world-class diving spots, and opportunities to explore hidden caves and pristine marine sanctuaries. El Nido is perfect for adventure seekers and nature lovers seeking untouched beauty.',
    image: "https://images.unsplash.com/photo-1627205897207-f763375e2c4d",
    imageAlt: 'El Nido dramatic limestone cliffs rising from turquoise lagoon with traditional boats and tropical vegetation',
    rating: 4.9,
    reviews: 9876,
    priceFrom: 3200,
    isHiddenGem: false,
    isFeatured: true,
    features: [
    { icon: 'Mountain', label: 'Limestone Cliffs' },
    { icon: 'Waves', label: 'Hidden Lagoons' },
    { icon: 'Fish', label: 'Diving Spots' },
    { icon: 'Camera', label: 'Photography' }],

    gallery: [
    {
      url: "https://images.unsplash.com/photo-1682784552296-17bb2ec46710",
      alt: 'El Nido Big Lagoon with towering limestone formations, crystal clear water, and kayakers exploring'
    },
    {
      url: "https://images.unsplash.com/photo-1686019837067-cd79f967cdf9",
      alt: 'El Nido sunset view with silhouetted karst cliffs and golden sky reflecting on calm waters'
    }],

    hotels: [
    {
      name: 'Lio Beach Resort',
      rating: 4.6,
      price: 6800,
      image: "https://images.unsplash.com/photo-1724372657711-81e07f76a393",
      imageAlt: 'Modern Lio Beach Resort with contemporary architecture, beachfront location, and tropical landscaping'
    }],

    restaurants: [
    {
      name: 'Artcafe',
      cuisine: 'International',
      avgPrice: 850,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bbb3a1ca-1768580138302.png",
      imageAlt: 'Artcafe El Nido with artistic decor, colorful murals, and open-air dining area'
    }],

    transport: [
    {
      type: 'Van Transfer',
      description: 'Puerto Princesa to El Nido',
      price: 850,
      icon: 'Car'
    }]

  },
  {
    id: 3,
    name: 'Siargao',
    location: 'Surigao del Norte, Caraga',
    description: 'Surfing capital of the Philippines with world-class waves and laid-back island vibes',
    fullDescription: 'Siargao is the ultimate destination for surfers and beach lovers, famous for Cloud 9, one of the world\'s best surf breaks. Beyond surfing, the island offers stunning rock pools, pristine beaches, island hopping adventures, and a vibrant community of travelers. Experience the perfect blend of adventure, relaxation, and authentic Filipino island culture.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_185718670-1765205413169.png",
    imageAlt: 'Siargao Cloud 9 surf break with perfect barrel waves, wooden pier, and surfers riding tropical waves',
    rating: 4.7,
    reviews: 7654,
    priceFrom: 2800,
    isHiddenGem: false,
    isFeatured: true,
    features: [
    { icon: 'Waves', label: 'World-Class Surfing' },
    { icon: 'Palmtree', label: 'Island Hopping' },
    { icon: 'Droplets', label: 'Rock Pools' },
    { icon: 'Users', label: 'Backpacker Hub' }],

    gallery: [
    {
      url: "https://img.rocket.new/generatedImages/rocket_gen_img_185718670-1765205413169.png",
      alt: 'Siargao Cloud 9 boardwalk with surfers carrying boards and perfect waves breaking in background'
    }],

    hotels: [
    {
      name: 'Nay Palad Hideaway',
      rating: 4.8,
      price: 9500,
      image: "https://images.unsplash.com/photo-1728049006252-020dfb896026",
      imageAlt: 'Luxury Nay Palad Hideaway resort with private villas, infinity pool, and lush tropical gardens'
    }],

    restaurants: [
    {
      name: 'Kermit Restaurant',
      cuisine: 'Italian-Filipino',
      avgPrice: 750,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11a995b93-1770047454273.png",
      imageAlt: 'Kermit Restaurant Siargao with casual beachfront setting, wooden tables, and Italian pizza oven'
    }],

    transport: [
    {
      type: 'Motorbike Rental',
      description: 'Daily rental with helmet',
      price: 450,
      icon: 'Bike'
    }]

  },
  {
    id: 4,
    name: 'Siquijor',
    location: 'Central Visayas',
    description: 'Mystical island known for healing traditions, waterfalls, and enchanting natural beauty',
    fullDescription: 'Siquijor is a mystical island steeped in folklore and natural wonders. Known for its traditional healers and enchanting atmosphere, the island features stunning waterfalls, pristine beaches, centuries-old churches, and vibrant marine life. Discover hidden caves, swim in natural springs, and experience the unique spiritual culture that makes Siquijor truly magical.',
    image: "https://images.unsplash.com/photo-1642477216637-711224385c7f",
    imageAlt: 'Siquijor Cambugahay Falls with turquoise pools, rope swings, and lush tropical forest surroundings',
    rating: 4.6,
    reviews: 4321,
    priceFrom: 1800,
    isHiddenGem: true,
    isFeatured: false,
    features: [
    { icon: 'Sparkles', label: 'Mystical Culture' },
    { icon: 'Droplets', label: 'Waterfalls' },
    { icon: 'Church', label: 'Historic Sites' },
    { icon: 'Fish', label: 'Snorkeling' }],

    gallery: [
    {
      url: "https://img.rocket.new/generatedImages/rocket_gen_img_16b065057-1770047455223.png",
      alt: 'Siquijor Cambugahay Falls multi-tiered waterfall with crystal clear pools and visitors swimming'
    }],

    hotels: [
    {
      name: 'Coco Grove Beach Resort',
      rating: 4.5,
      price: 4200,
      image: "https://images.unsplash.com/photo-1714486337547-c86707178ce8",
      imageAlt: 'Coco Grove Beach Resort with traditional Filipino cottages, beachfront location, and palm trees'
    }],

    restaurants: [
    {
      name: 'Dagsa Restaurant',
      cuisine: 'Filipino Seafood',
      avgPrice: 650,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10f95c83b-1770047454317.png",
      imageAlt: 'Dagsa Restaurant beachfront dining with fresh seafood display and traditional Filipino cooking'
    }],

    transport: [
    {
      type: 'Tricycle Tour',
      description: 'Full island tour with guide',
      price: 1200,
      icon: 'Car'
    }]

  },
  {
    id: 5,
    name: 'Bohol',
    location: 'Central Visayas',
    description: 'Home to the famous Chocolate Hills, tarsiers, and beautiful beaches',
    fullDescription: 'Bohol is a diverse destination featuring the iconic Chocolate Hills, the world\'s smallest primate (Philippine Tarsier), pristine beaches, and rich cultural heritage. Explore centuries-old churches, cruise along the Loboc River, dive in world-class sites, and experience the warmth of Boholano hospitality. This island offers a perfect mix of natural wonders and cultural treasures.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b0cc8076-1765205412107.png",
    imageAlt: 'Bohol Chocolate Hills landscape with hundreds of cone-shaped hills covered in brown grass during dry season',
    rating: 4.7,
    reviews: 8765,
    priceFrom: 2200,
    isHiddenGem: false,
    isFeatured: true,
    features: [
    { icon: 'Mountain', label: 'Chocolate Hills' },
    { icon: 'Eye', label: 'Tarsier Sanctuary' },
    { icon: 'Ship', label: 'River Cruise' },
    { icon: 'Church', label: 'Historic Churches' }],

    gallery: [
    {
      url: "https://images.unsplash.com/photo-1505314960618-8c45d9c16329",
      alt: 'Bohol Chocolate Hills panoramic view with viewing deck and tourists admiring geological formations'
    }],

    hotels: [
    {
      name: 'Amorita Resort',
      rating: 4.8,
      price: 7800,
      image: "https://images.unsplash.com/photo-1570591070094-f9b1cc333b71",
      imageAlt: 'Amorita Resort Bohol with infinity pool overlooking ocean, modern architecture, and sunset views'
    }],

    restaurants: [
    {
      name: 'Gerarda\'s',
      cuisine: 'Filipino',
      avgPrice: 550,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_13c9964da-1765211058221.png",
      imageAlt: 'Gerarda\'s family restaurant with traditional Filipino dishes, wooden interior, and local artwork'
    }],

    transport: [
    {
      type: 'Countryside Tour',
      description: 'Full day with lunch included',
      price: 1500,
      icon: 'Car'
    }]

  },
  {
    id: 6,
    name: 'Sagada',
    location: 'Mountain Province, Cordillera',
    description: 'Mountain town famous for hanging coffins, caves, and stunning rice terraces',
    fullDescription: 'Sagada is a serene mountain town offering cool climate, breathtaking landscapes, and unique cultural experiences. Famous for its hanging coffins, underground caves, and spectacular sunrise views at Kiltepan Peak, Sagada provides a peaceful retreat from tropical beaches. Trek through rice terraces, explore limestone caves, and immerse yourself in indigenous Igorot culture.',
    image: "https://images.unsplash.com/photo-1507297388516-e94e54b93567",
    imageAlt: 'Sagada hanging coffins attached to limestone cliff face with mountain landscape and pine trees',
    rating: 4.8,
    reviews: 5432,
    priceFrom: 1500,
    isHiddenGem: true,
    isFeatured: false,
    features: [
    { icon: 'Mountain', label: 'Mountain Views' },
    { icon: 'Sunrise', label: 'Sunrise Viewing' },
    { icon: 'Cave', label: 'Cave Exploration' },
    { icon: 'Leaf', label: 'Rice Terraces' }],

    gallery: [
    {
      url: "https://images.unsplash.com/photo-1730145311888-303644e13148",
      alt: 'Sagada Kiltepan viewpoint at sunrise with sea of clouds, mountain ranges, and golden light'
    }],

    hotels: [
    {
      name: 'Sagada Heritage Village',
      rating: 4.4,
      price: 2800,
      image: "https://images.unsplash.com/photo-1530122037265-a5f1f91d3b99",
      imageAlt: 'Sagada Heritage Village traditional mountain lodge with wooden construction and mountain views'
    }],

    restaurants: [
    {
      name: 'Yoghurt House',
      cuisine: 'Cafe',
      avgPrice: 350,
      image: "https://images.unsplash.com/photo-1562835155-1fa627c69744",
      imageAlt: 'Yoghurt House Sagada cozy cafe interior with wooden furniture, warm lighting, and mountain decor'
    }],

    transport: [
    {
      type: 'Jeepney Tour',
      description: 'Town and caves tour',
      price: 800,
      icon: 'Car'
    }]

  },
  {
    id: 7,
    name: 'Batanes',
    location: 'Cagayan Valley',
    description: 'Northernmost province with rolling hills, dramatic cliffs, and unique Ivatan culture',
    fullDescription: 'Batanes is the Philippines\' northernmost frontier, offering dramatic landscapes of rolling hills, rugged coastlines, and traditional stone houses. Experience the unique Ivatan culture, witness breathtaking sunrises and sunsets, explore historic lighthouses, and enjoy the pristine beauty of this remote paradise. Batanes provides an authentic, unspoiled Philippine experience unlike any other destination.',
    image: "https://images.unsplash.com/photo-1648498030198-19f17e26eda4",
    imageAlt: 'Batanes rolling green hills with traditional Ivatan stone houses, grazing cattle, and dramatic coastal cliffs',
    rating: 4.9,
    reviews: 3210,
    priceFrom: 4500,
    isHiddenGem: true,
    isFeatured: false,
    features: [
    { icon: 'Mountain', label: 'Rolling Hills' },
    { icon: 'Home', label: 'Stone Houses' },
    { icon: 'Lighthouse', label: 'Lighthouses' },
    { icon: 'Users', label: 'Ivatan Culture' }],

    gallery: [
    {
      url: "https://img.rocket.new/generatedImages/rocket_gen_img_113de99e4-1770047453550.png",
      alt: 'Batanes Valugan Boulder Beach with massive rounded stones, crashing waves, and mountain backdrop'
    }],

    hotels: [
    {
      name: 'Fundacion Pacita',
      rating: 4.7,
      price: 5500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15b728764-1770047454160.png",
      imageAlt: 'Fundacion Pacita Batanes boutique hotel with traditional architecture, art gallery, and ocean views'
    }],

    restaurants: [
    {
      name: 'Honesty Coffee Shop',
      cuisine: 'Cafe',
      avgPrice: 250,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19ea965ce-1770047459155.png",
      imageAlt: 'Honesty Coffee Shop Batanes self-service cafe with honor system payment and local coffee'
    }],

    transport: [
    {
      type: 'Bike Rental',
      description: 'Daily rental for island exploration',
      price: 350,
      icon: 'Bike'
    }]

  },
  {
    id: 8,
    name: 'Puerto Princesa',
    location: 'Palawan, MIMAROPA',
    description: 'Gateway to the Underground River, a UNESCO World Heritage Site',
    fullDescription: 'Puerto Princesa is the capital of Palawan and gateway to the world-famous Underground River, a UNESCO World Heritage Site. This eco-friendly city offers pristine beaches, mangrove forests, wildlife sanctuaries, and island hopping adventures. Experience sustainable tourism, explore limestone caves, and discover why Palawan is consistently rated as one of the world\'s best islands.',
    image: "https://images.unsplash.com/photo-1728395578700-d7e994faf053",
    imageAlt: 'Puerto Princesa Underground River entrance with limestone cave opening, turquoise water, and tour boats',
    rating: 4.7,
    reviews: 11234,
    priceFrom: 2800,
    isHiddenGem: false,
    isFeatured: true,
    features: [
    { icon: 'Mountain', label: 'Underground River' },
    { icon: 'Leaf', label: 'Eco-Tourism' },
    { icon: 'Fish', label: 'Island Hopping' },
    { icon: 'Bird', label: 'Wildlife' }],

    gallery: [
    {
      url: "https://images.unsplash.com/photo-1596395212390-3047bb247ef7",
      alt: 'Puerto Princesa Underground River interior with stalactites, stalagmites, and boat tour exploring cave'
    }],

    hotels: [
    {
      name: 'Sheridan Beach Resort',
      rating: 4.6,
      price: 5200,
      image: "https://images.unsplash.com/photo-1619900865184-72811847545e",
      imageAlt: 'Sheridan Beach Resort Puerto Princesa with beachfront cottages, swimming pool, and tropical gardens'
    }],

    restaurants: [
    {
      name: 'Kalui Restaurant',
      cuisine: 'Filipino Seafood',
      avgPrice: 850,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d8666dd7-1770047458125.png",
      imageAlt: 'Kalui Restaurant unique floor seating with colorful cushions, fresh seafood, and artistic decor'
    }],

    transport: [
    {
      type: 'Underground River Tour',
      description: 'Full day with permits and lunch',
      price: 2200,
      icon: 'Ship'
    }]

  },
  {
    id: 9,
    name: 'Banaue',
    location: 'Ifugao, Cordillera',
    description: '2000-year-old rice terraces carved into mountains, a UNESCO World Heritage Site',
    fullDescription: 'Banaue is home to the magnificent Rice Terraces, often called the "Eighth Wonder of the World." These 2000-year-old terraces were hand-carved into the mountains by the Ifugao people and remain a living cultural landscape. Trek through ancient pathways, visit traditional villages, experience indigenous culture, and witness the engineering marvel that has sustained communities for millennia.',
    image: "https://images.unsplash.com/photo-1717218761729-43db5ebf4198",
    imageAlt: 'Banaue Rice Terraces panoramic view with stepped green terraces carved into mountain slopes and traditional huts',
    rating: 4.8,
    reviews: 6543,
    priceFrom: 1800,
    isHiddenGem: false,
    isFeatured: true,
    features: [
    { icon: 'Mountain', label: 'Rice Terraces' },
    { icon: 'Users', label: 'Indigenous Culture' },
    { icon: 'Footprints', label: 'Trekking' },
    { icon: 'Camera', label: 'Photography' }],

    gallery: [
    {
      url: "https://images.unsplash.com/photo-1728836047808-3048a7fca12b",
      alt: 'Banaue Rice Terraces at sunrise with golden light illuminating terraced fields and mountain mist'
    }],

    hotels: [
    {
      name: 'Banaue Hotel',
      rating: 4.3,
      price: 3200,
      image: "https://images.unsplash.com/photo-1558501113-a8158a8fee75",
      imageAlt: 'Banaue Hotel traditional mountain lodge with wooden architecture and rice terrace views'
    }],

    restaurants: [
    {
      name: 'People\'s Lodge Restaurant',
      cuisine: 'Filipino',
      avgPrice: 450,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b5c0d02e-1770047455423.png",
      imageAlt: 'People\'s Lodge Restaurant serving traditional Ifugao cuisine with mountain views and local ingredients'
    }],

    transport: [
    {
      type: 'Trekking Guide',
      description: 'Full day terrace trek with guide',
      price: 1000,
      icon: 'Footprints'
    }]

  },
  {
    id: 10,
    name: 'Kalanggaman',
    location: 'Leyte, Eastern Visayas',
    description: 'Pristine sandbar island with crystal-clear waters and minimal development',
    fullDescription: 'Kalanggaman Island is an untouched paradise featuring a stunning white sandbar that stretches into crystal-clear turquoise waters. This remote island offers pristine beaches, excellent snorkeling, and a peaceful escape from crowds. With minimal development and no permanent structures, Kalanggaman provides an authentic deserted island experience perfect for day trips and nature lovers.',
    image: "https://images.unsplash.com/photo-1504814532849-cff240bbc503",
    imageAlt: 'Kalanggaman Island aerial view showing long white sandbar extending into turquoise ocean with palm trees',
    rating: 4.9,
    reviews: 2876,
    priceFrom: 2500,
    isHiddenGem: true,
    isFeatured: false,
    features: [
    { icon: 'Waves', label: 'Sandbar' },
    { icon: 'Fish', label: 'Snorkeling' },
    { icon: 'Palmtree', label: 'Pristine Beach' },
    { icon: 'Camera', label: 'Photography' }],

    gallery: [
    {
      url: "https://images.unsplash.com/photo-1566105683384-4738b6a3c067",
      alt: 'Kalanggaman Island sandbar with clear shallow water, white sand, and coconut palms swaying in breeze'
    }],

    hotels: [
    {
      name: 'Palompon Lodging House',
      rating: 4.0,
      price: 1500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_12a2d0eb8-1770047454330.png",
      imageAlt: 'Simple Palompon lodging house with basic rooms, fan cooling, and local Filipino hospitality'
    }],

    restaurants: [
    {
      name: 'Local Eatery',
      cuisine: 'Filipino',
      avgPrice: 250,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fb93b35e-1769389443471.png",
      imageAlt: 'Local Filipino eatery with simple wooden tables, home-cooked meals, and friendly service'
    }],

    transport: [
    {
      type: 'Island Day Trip',
      description: 'Boat transfer and snorkeling gear',
      price: 1800,
      icon: 'Ship'
    }]

  },
  {
    id: 11,
    name: 'Zamboanga',
    location: 'Zamboanga Peninsula, Mindanao',
    description: 'City of flowers with pink sand beaches, vibrant culture, and Spanish colonial heritage',
    fullDescription: 'Zamboanga City, known as "Asia\'s Latin City," offers a unique blend of Spanish, Muslim, and Filipino cultures. Famous for its pink sand beaches, colorful vintas (traditional boats), and the historic Fort Pilar, Zamboanga provides diverse experiences from island hopping to cultural immersion. Explore the Great Santa Cruz Island, taste local delicacies, and experience the warmth of Zamboangueño hospitality.',
    image: "https://images.unsplash.com/photo-1565369730053-d6669ea47d5f",
    imageAlt: 'Zamboanga Great Santa Cruz Island pink sand beach with colorful vintas boats and turquoise water',
    rating: 4.5,
    reviews: 4567,
    priceFrom: 2000,
    isHiddenGem: true,
    isFeatured: false,
    features: [
    { icon: 'Waves', label: 'Pink Sand Beach' },
    { icon: 'Ship', label: 'Vinta Boats' },
    { icon: 'Castle', label: 'Fort Pilar' },
    { icon: 'Users', label: 'Cultural Diversity' }],

    gallery: [
    {
      url: "https://img.rocket.new/generatedImages/rocket_gen_img_10da08a58-1770047455484.png",
      alt: 'Zamboanga colorful vintas with vibrant sails racing on turquoise water during annual regatta festival'
    }],

    hotels: [
    {
      name: 'Garden Orchid Hotel',
      rating: 4.4,
      price: 3500,
      image: "https://images.unsplash.com/photo-1648644788905-6f13219b59fe",
      imageAlt: 'Garden Orchid Hotel Zamboanga with tropical gardens, swimming pool, and Spanish colonial architecture'
    }],

    restaurants: [
    {
      name: 'Alavar Seafood Restaurant',
      cuisine: 'Filipino Seafood',
      avgPrice: 650,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ac9a039c-1770047452129.png",
      imageAlt: 'Alavar Seafood Restaurant famous for curacha and fresh seafood dishes with local Zamboanga flavors'
    }],

    transport: [
    {
      type: 'Pink Beach Tour',
      description: 'Great Santa Cruz Island day trip',
      price: 1200,
      icon: 'Ship'
    }]

  }];


  const filteredDestinations = destinations?.filter((destination) => {
    if (activeFilters?.length === 0) return true;

    const matchesType =
    activeFilters?.includes('featured') && destination?.isFeatured ||
    activeFilters?.includes('hidden') && destination?.isHiddenGem;

    const matchesPrice =
    activeFilters?.includes('budget') && destination?.priceFrom < 3000 ||
    activeFilters?.includes('moderate') && destination?.priceFrom >= 3000 && destination?.priceFrom < 7000 ||
    activeFilters?.includes('luxury') && destination?.priceFrom >= 7000;

    return matchesType || matchesPrice || activeFilters?.some((filter) =>
    ['hotels', 'restaurants', 'transport', 'activities', 'beach', 'mountain']?.includes(filter)
    );
  });

  const handleDestinationClick = (destination) => {
    setSelectedDestination(destination);
    setIsDestinationModalOpen(true);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e?.ctrlKey || e?.metaKey) && e?.key === 'k') {
        e?.preventDefault();
        setIsSearchModalOpen(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="main-content">
        <HeroSection onSearchClick={() => setIsSearchModalOpen(true)} />

        {/* Map & Filter Section */}
        <section className="py-12 md:py-16 lg:py-20">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
            <div className="text-center mb-8 md:mb-10 lg:mb-12">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4">
                Explore Philippine Destinations
              </h2>
              <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
                Click on the map pins or use filters to discover your perfect destination
              </p>
            </div>

            <div className="flex flex-col lg:flex-row gap-6 md:gap-8">
              <div className="lg:order-1">
                <FilterPanel
                  onFilterChange={setActiveFilters}
                  activeFilters={activeFilters} />

              </div>

              <div className="flex-1 lg:order-2">
                <InteractiveMap
                  destinations={destinations}
                  onDestinationClick={handleDestinationClick}
                  activeFilters={activeFilters} />

              </div>
            </div>
          </div>
        </section>

        {/* Destinations Grid */}
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5">
          {filteredDestinations?.map((destination) => (
            <DestinationCard
              key={destination?.id}
              destination={destination}
              onClick={() => handleDestinationClick(destination)}
            />
          ))}
        </div>

        <EmergencyBanner />
        <OfficialPartners />
        <SafetySection />
        <FeaturedPartners />
      </main>
      <Footer />
      <SearchModal
        isOpen={isSearchModalOpen}
        onClose={() => setIsSearchModalOpen(false)} />

      <DestinationModal
        destination={selectedDestination}
        isOpen={isDestinationModalOpen}
        onClose={() => setIsDestinationModalOpen(false)} />

    </div>);

};

export default Homepage;